import type { CrmRelationship, CrmStage } from '@discovr/features';
import { cn } from '../../../lib/utils';
import { CRM_RELATIONSHIP_STYLES, CRM_STAGE_STYLES } from './crmStageStyles';
import { PILL_BASE } from './OutreachStatusPill';

export function CrmStagePill({ stage }: { stage: CrmStage }) {
  const style = CRM_STAGE_STYLES[stage];
  return <span className={cn(PILL_BASE, style.cls)}>{style.label}</span>;
}

export function CrmRelationshipPill({ relationship }: { relationship: CrmRelationship }) {
  const style = CRM_RELATIONSHIP_STYLES[relationship];
  return <span className={cn(PILL_BASE, style.cls)}>{style.label}</span>;
}
